<template>
  <div class="collection-item-creator">
    <SelectOption
      :removeable="false"
      :options="options"
      :customLabel="'title'"
      :placeholder="getPlaceHolder(collectionType)"
      @onChanged="onSelected"
      @onSearch="debounceSearch"/>
  </div>
</template>

<script>
import _ from 'lodash';
import SelectOption from '@/components/SelectOption.vue';
import {
  getLoadByCollectionType,
  getSelectorCollectionTypePlaceHolder,
} from './collectionManagement';

export default {
  props: {
    collectionItems: {
      type: Array,
      default: () => [],
    },
    collectionType: {
      type: String,
      default: 'Video',
    },
  },
  data() {
    return {
      options: [],
      debounce: null,
    };
  },
  components: {
    SelectOption,
  },
  created() {
    this.load();
  },
  watch: {
    collectionType(newVal) {
      const filter = null;
      this.load(filter, newVal);
    },
  },
  methods: {
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.load(event);
      }, 500);
    },
    async load(filter) {
      const response = await getLoadByCollectionType(filter, this.collectionType);
      this.options = response.data.data;
    },
    onSelected(selectOption) {
      if (selectOption) {
        const newCollectionItem = _.find(this.options, (optionItem) => optionItem.id === selectOption);
        const formatCollection = {
          collectionDetailId: null,
          createdAt: null,
          deleted: false,
          itemId: newCollectionItem.id,
          index: null,
          [this.collectionType]: newCollectionItem,
          type: this.collectionType,
        };
        if (!this.isCollectionItemExist(formatCollection)) {
          this.$emit('update:collectionItems', [formatCollection, ...this.collectionItems]);
        }
      }
    },
    isCollectionItemExist(collection) {
      return _.find(this.collectionItems, (item) => item.itemId === collection.itemId);
    },
    getPlaceHolder(collectionType) {
      return `${getSelectorCollectionTypePlaceHolder(collectionType)} หรือค้นหาด้วยชื่อ`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.collection-item-creator {
  width: 100%;
}
</style>
